import React from 'react';
import { Briefcase, Compass, FlaskConical, GraduationCap, HeartHandshake, Landmark, Stethoscope } from 'lucide-react';
import type { DemoDomain } from '../../data/demoCenter';
const icons: Record<DemoDomain['id'], React.ComponentType<{
  size?: number;
  className?: string;
  'aria-hidden'?: boolean;
}>> = {
  government: Landmark,
  research: FlaskConical,
  education: GraduationCap,
  talent: Briefcase,
  community: HeartHandshake,
  leadership: Compass,
  clinical: Stethoscope
};
type DomainIconProps = {
  id: DemoDomain['id'];
  size?: 'md' | 'lg';
};
export function DomainIcon({
  id,
  size = 'md'
}: DomainIconProps) {
  const Icon = icons[id];
  const box = size === 'lg' ? 'h-12 w-12' : 'h-10 w-10';
  return <span aria-hidden="true" className={`inline-flex ${box} shrink-0 items-center justify-center rounded-lg bg-lavender-pale text-lavender border border-lavender/15`} data-id="element-389" data-mp="2dqhjos62ufym">
      <Icon size={size === 'lg' ? 22 : 20} aria-hidden data-id="element-390" data-mp="2mrxq6otrtxxk" />
    </span>;
}